module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "its-all-an-act"
    }
  }, [_c('h1', {
    staticClass: "unnumbered"
  }, [_vm._v("It’s All An Act")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("It’s All an Act")]), _vm._v(" reads with great clarity and provides a plethora of useful suggestions for trainee teachers to consider, as they begin their professional career.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The narrative is engaging, and we can clearly visualise the wide range of examples from the classroom that he explores. These are supported by informative, practical strategies that can be considered, trialled and adopted if they work for the individual.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The emphasis on positivity, fairness and consistency that permeates the work sets an important tone that trainee teachers need to hear, as does the recognition that sometimes we need to admit we have got it wrong.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("This is a great resource for all early career teachers but particularly the trainee teacher.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Eluned Pickup,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Senior teaching fellow and Secondary PGCE tutor,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("University of Southampton.")]), _vm._v(" "), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0